export default {
    breadcrumbRoutes: [], // 保存的面包屑的路由

    listApis: {}, // 列表视图 apilist
    listview: {},
    listApiData: null,
    listviewDetail: {},

    formApis: {}, // 表单视图 apilist
    formview: {},
    formApiData: null,
    formviewDetail: {},

    engineList: []
}
